import React from 'react';
import './style.scss';

export const DocumentHeader = () => {
  return (
    <>
      <div className="documentHeader">
        <div className="documentHeader_download">ダウンロード</div>
        <div className="documentHeader_title">書類名</div>
        <div className="documentHeader_date">交付日</div>
      </div>
    </>
  );
};
